import React from 'react';
import Button from 'components/buttons/Button';

const ShareArticleButton = ({ handleClick }: { handleClick: () => void }) => {
    return (
        <div className="flex items-center gap-4">
            <strong className="hidden xl:inline-block">Deli namig</strong>
            <div>
                <Button color="secondary" onClick={handleClick}>
                    Deli
                </Button>
            </div>
        </div>
    );
};

export default ShareArticleButton;
